import { action } from './utils';

export const SET_DISPLAYED_ENTITY_COUNT = 'SET_DISPLAYED_ENTITY_COUNT';

export const setDisplayedEntityCountAction = (containerId: string, displayedEntityCount: number) =>
  action(SET_DISPLAYED_ENTITY_COUNT, { payload: { containerId, displayedEntityCount } });
